<template>
  <card id="evaluations" ref="evaluationref">
    <h2 slot="header" class="card-title">{{$t('reports.evaluations')}}</h2>
    <div class="row">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <div>
            <el-table :data="filteredRegions">
              <el-table-column
                sortable
                label="Region Name"
                min-width="50"
                property="name"
              ></el-table-column>
              <el-table-column
                sortable
                label="Region Code"
                min-width="50"
                property="code"
              >
              </el-table-column>
              <el-table-column align="right" min-width="150" label="Actions">
                <div slot-scope="props">
                  <base-button
                    class="mb-1"
                    type="info"
                    size="sm"
                    @click="downloadEvaluation(props.row.regionId)"
                  >
                    Consolidate Report
                  </base-button>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                Showing {{ pagination.from }} to {{ pagination.to }} of {{ pagination.total }} entries
              </p>
            </div>
            <base-pagination
              v-if="evaluations.length"
              @input="getItems"
              class="pagination-no-border"
              v-model="pagination.current_page"
              :per-page="pagination.per_page"
              :total="pagination.total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>
  </card>
</template>
<script>
  import {Table, TableColumn, Select, Option} from 'element-ui';
  import {BasePagination, Modal, GenerateReports} from 'src/components';
  import {ReportsService, RegionService, UserRoles} from '@/services';

  export default {
    components: {
      GenerateReports,
      BasePagination,
      [Select.name]: Select,
      [Option.name]: Option,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      Modal
    },
    data() {
      return {
        initialized: false,
        pagination: {},
        sortColumn: undefined,
        sortOrder: undefined,
        perPage: 16,
        searchQuery: undefined,
        loggedUser: {},
        propsToSearch: ['reference', 'title', 'user_details.email', 'user_details.name', 'user_details.organisation_legal_name', 'region_details.name', 'countries.name', 'status'],
        regions: [],
        evaluations: [],
        filterOptions: [],
        filters: {
          status: undefined,
          countries: [],
          regions: []
        },
        evaluationTypes: [],
        modalEvaluate: {
          visibility: false,
          application: {}
        }
      };
    },
    computed: {
      filteredRegions: function ()
      {
        let vm = this;

        if (vm.loggedUser.role === UserRoles.ADMIN)
        {
          return this.regions;
        }

        return vm.regions.filter((region) =>
        {
          return region.regionId === vm.loggedUser.region.regionId;
        });

      },
    },
    methods: {
      async getItems(page) {
        let vm = this;
        let page_to_get = page || vm.pagination.current_page;

        let loader = vm.$loading.show();

        await RegionService.getRegions().then((response) =>
        {
          vm.regions = response.data;
        });

        loader.hide();
      },
      downloadEvaluation(region_id)
      {
        let loader = this.$loading.show();

        ReportsService.exportEvaluation({
          region_id: region_id
        }).then((response) =>
        {
          if (response.data && response.data.success)
          {
            window.open(response.data.url, '_blank');
          }

          loader.hide();
        });
      },
      viewEvaluation(user_id) {
        window.open('/reports/evaluations/grid/' + user_id, '_blank');
      },
      viewApplication(user_id) {
        window.open('/documents/fill/' + user_id, '_blank');
      }
    },
    mounted() {
      let vm = this;
      vm.loggedUser = vm.$store.getters['Auth/loggedUser'];
      vm.getItems();
    }
  };
</script>
<style lang="scss" scoped>
  .card-body {
    button {
      margin-left: 1rem;
    }
  }

  button {
    white-space: nowrap;
  }

  .evaluations-list {
    list-style-type: disc !important;
  }
</style>
